/**
 * Created: 2024-03-27
 * Last Modified: 2024-03-27
 *
 * ErrorBoundary Component
 * Catches and handles React rendering errors
 */

'use client'

import React, {Component, ReactNode} from 'react'
import {ErrorPage} from './ErrorPage'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      hasError: false,
      error: null
    }
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage title="Something went wrong" message="An unexpected error occurred. Please try again." error={this.state.error?.message} showHomeButton={true} />
    }

    return this.props.children
  }
}
